export const RECENT_SEARCHES_STORAGE_KEY = 'recentSearches';
export const MAX_RECENT_SEARCHES = 5;

function normalizeRecentSearchIdentityPart(value) {
    return String(value || '').trim().toLowerCase();
}

function deduplicateRecentSearchEntries(entries) {
    const seenIdentities = new Set();
    const deduplicatedEntries = [];

    entries.forEach((entry) => {
        const identity = buildRecentSearchIdentity(entry);
        if (seenIdentities.has(identity)) {
            return;
        }

        seenIdentities.add(identity);
        deduplicatedEntries.push(entry);
    });

    return deduplicatedEntries;
}

export function loadRecentSearches() {
    if (typeof window === 'undefined') {
        return [];
    }

    try {
        const rawValue = localStorage.getItem(RECENT_SEARCHES_STORAGE_KEY);
        if (!rawValue) {
            return [];
        }

        const parsedValue = JSON.parse(rawValue);
        return Array.isArray(parsedValue)
            ? deduplicateRecentSearchEntries(parsedValue).slice(0, MAX_RECENT_SEARCHES)
            : [];
    } catch {
        return [];
    }
}

export function saveRecentSearches(nextRecentSearches) {
    if (typeof window === 'undefined') {
        return;
    }

    localStorage.setItem(
        RECENT_SEARCHES_STORAGE_KEY,
        JSON.stringify(
            deduplicateRecentSearchEntries(nextRecentSearches).slice(0, MAX_RECENT_SEARCHES)
        ),
    );
}

function buildRecentSearchIdentity(entry) {
    if (entry.kind === 'summoner') {
        return `summoner:${normalizeRecentSearchIdentityPart(entry.displayRegion)}:${normalizeRecentSearchIdentityPart(entry.gameName)}:${normalizeRecentSearchIdentityPart(entry.tagLine)}`;
    }

    return `${normalizeRecentSearchIdentityPart(entry.kind)}:${normalizeRecentSearchIdentityPart(entry.displayRegion)}:${normalizeRecentSearchIdentityPart(entry.query)}`;
}

export function mergeRecentSearchEntry(previousEntries, nextEntry) {
    const nextIdentity = buildRecentSearchIdentity(nextEntry);
    const deduplicatedEntries = previousEntries.filter(
        (entry) => buildRecentSearchIdentity(entry) !== nextIdentity
    );

    return [nextEntry, ...deduplicatedEntries].slice(0, MAX_RECENT_SEARCHES);
}
